export default __webpack_public_path__ + "static/media/Vanilla-Euphoria-2.aa322e01.jpg";